import FluxUtils from 'flux/utils';

import SettingsActions from 'sharedreact/actions/SettingsActions';
import UserPreferencesActions from 'sharedreact/actions/UserPreferencesActions';
import SettingsSlideOut from 'sharedreact/components/SettingsSlideOut';
import asFunctional from 'sharedreact/components/asFunctional';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

function hide () {
  SettingsActions.hide();
}

type Props = {
  showUnits?: boolean
};

type State = ConstructorParameters<typeof SettingsSlideOut>[0];

function getStores () {
  return [
    SettingsStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    settings: SettingsStore.getSettings(),
    show: SettingsStore.getState().isVisible,
    showUnits: (props.showUnits === undefined || props.showUnits === null) ? true : props.showUnits,
    isBusy: SettingsStore.isBusy(),
    newLanguage: SettingsStore.getState().newLanguage ?? undefined,
    onChangeValue: SettingsActions.setValue,
    onClearPreferences: UserPreferencesActions.clear,
    onClose: hide
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(SettingsSlideOut),
  getStores,
  calculateState,
  { withProps: true }
);
